import React, { Component } from 'react';
import { DeadlineBanner } from '../components/DeadlineBanner';
import { NewHero } from '../components/NewHero';
import { NewProblemSection } from '../components/NewProblemSection';
import { AlexandriaSection } from '../components/AlexandriaSection';
import { PSIGatheringSection } from '../components/PSIGatheringSection';
import { PSIProDifferenceSection } from '../components/PSIProDifferenceSection';
import { PSIProBenefitsSection } from '../components/PSIProBenefitsSection';
import { PeptideMasteryDetailSection } from '../components/PeptideMasteryDetailSection';
import { DirectAccessSection } from '../components/DirectAccessSection';
import { PeptideMasteryComponent } from '../components/PeptideMasteryComponent';
import { FreeOfferReveal } from '../components/FreeOfferReveal';
import { ApplicationAndPricingSection } from '../components/ApplicationAndPricingSection';
import { QualificationSection } from '../components/QualificationSection';
import { NoGuarantee } from '../components/NoGuarantee';
import { ProTestimonials } from '../components/ProTestimonials';
import { FAQSection } from '../components/FAQSection';
import { StakesSection } from '../components/StakesSection';
import { DeadlineScarcity } from '../components/DeadlineScarcity';
import { FinalCTA } from '../components/FinalCTA';
import { MysteryLayer } from '../components/MysteryLayer';
import { MonthlyUpsellProvider } from '../components/MonthlyUpsellContext';
export function NewLandingPage() {
  return <MonthlyUpsellProvider data-id="element-5157">
      <div className="bg-black text-stone-200 min-h-screen relative overflow-x-hidden" data-id="element-5158">
        {/* Background layer */}
        <MysteryLayer data-id="element-5159" />

        {/* Sticky urgency banner */}
        <DeadlineBanner data-id="element-5160" />

        {/* HOOK */}
        <NewHero data-id="element-5161" />

        {/* PROBLEM / AGITATION */}
        <NewProblemSection data-id="element-5162" />

        {/* SOLUTION INTRO */}
        <AlexandriaSection data-id="element-5163" />
        <PSIGatheringSection data-id="element-5164" />

        {/* WHAT MAKES PRO DIFFERENT */}
        <PSIProDifferenceSection data-id="element-5165" />
        <PSIProBenefitsSection data-id="element-5166" />

        {/* WHAT YOU GET */}
        <PeptideMasteryDetailSection data-id="element-5167" />
        <DirectAccessSection data-id="element-5168" />
        <PeptideMasteryComponent data-id="element-5169" />

        {/* THE OFFER */}
        <FreeOfferReveal data-id="element-5170" />
        <ApplicationAndPricingSection data-id="element-5171" />

        {/* CLOSE */}
        <QualificationSection data-id="element-5172" />
        <NoGuarantee data-id="element-5173" />
        <ProTestimonials data-id="element-5174" />
        <FAQSection data-id="element-5175" />
        <StakesSection data-id="element-5176" />
        <DeadlineScarcity data-id="element-5177" />
        <FinalCTA data-id="element-5178" />
      </div>
    </MonthlyUpsellProvider>;
}